export default [
  {value: 'KR', name: '대한민국'},
  {value: 'CA', name: '캐나다'},
  {value: 'US', name: '미국(대륙)'}
];
